export const S3_Pool_conf = {
    Auth: {
        identityPoolId: 'us-west-2:2bf51988-3cf2-450c-aca9-19a3636b3e3e',
        region: 'us-west-2',
    },
    Storage: {
        AWSS3: {
            bucket: "media-conversion-stack-source-bucket-production",
            region: 'us-west-2',
        }
    }
};
